import React from 'react';
export function ProblemSection() {
  const problems = [{
    emoji: '😰',
    title: 'Creative Burnout',
    text: "You arrive at the gym exhausted after spending hours searching for drills online that don't fit your team's age or skill level."
  }, {
    emoji: '🏀',
    title: 'Lack of Structure',
    text: "Your practices feel disorganized. You improvise drills on the fly, and you're worried your players aren't mastering the essential fundamentals."
  }, {
    emoji: '📱',
    title: 'Information Overload',
    text: "There's too much noise out there. You don't know which offensive or defensive systems are actually proven to work for a developing team."
  }, {
    emoji: '😩',
    title: 'Massive Mental Load',
    text: "Between managing parents, game-day logistics, and technical planning, you've stopped enjoying the sport you're passionate about."
  }];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-187">
      <div className="max-w-5xl mx-auto" data-id="element-188">
        <div className="text-center mb-12" data-id="element-189">
          <div className="bg-bb-orange/10 text-bb-orange-dark font-bold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-190">
            Does This Sound Like You?
          </div>
          <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl md:text-5xl text-bb-charcoal leading-tight mb-5 tracking-tight" data-id="element-191">
            You love the game, but{' '}
            <span className="text-bb-orange" data-id="element-192">practice prep</span> is taking over
            your life
          </h2>
          <p className="text-lg text-bb-slate max-w-2xl mx-auto" data-id="element-193">
            If you're a basketball coach, you've likely faced one of these
            situations:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-194">
          {problems.map((p, idx) => <div key={idx} className="bg-bb-cream rounded-2xl p-7 border border-bb-line hover:border-bb-orange/40 hover:shadow-md hover:-translate-y-1 transition-all" data-id="element-195">
              <div className="text-4xl mb-3" data-id="element-196">{p.emoji}</div>
              <h3 className="font-display font-semibold uppercase text-xl text-bb-charcoal mb-2 tracking-wide" data-id="element-197">
                {p.title}
              </h3>
              <p className="text-bb-slate leading-relaxed" data-id="element-198">{p.text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}